import * as types from './types';

const initialState = {
  loading: false,
  recievedResponse: false,
  recievedSuccessfulResponse: false,
  recievedErrorResponse: false,
  currentPosting: '',
  isParticularNotFree: false,
  bulkSuccessful: 0,
  bulkError: 0
};

function suspendReducer(state = initialState, action) {
  switch (action.type) {
    case types.SUSPEND_POSTING:
      return {
        ...state,
        loading: true,
        recievedResponse: false,
        recievedSuccessfulResponse: false,
        recievedErrorResponse: false
      };

    case types.SUSPEND_POSTING_COMPLETED:
      return {
        ...state,
        loading: false,
        recievedResponse: true,
        recievedSuccessfulResponse: true,
        recievedErrorResponse: false,
        data: action.payload,
        isParticularNotFree: action.meta.particularNotFree,
        bulkSuccessful: action.payload.successfulPostings || 0,
        bulkError: action.payload.errorPostings || 0
      };
    case types.SUSPEND_POSTING_FAILED:
      return {
        ...state,
        loading: false,
        recievedResponse: true,
        recievedSuccessfulResponse: false,
        recievedErrorResponse: true,
        data: action.payload,
        isParticularNotFree: false,
        bulkError: action.meta.body.length || 1
      };

    case types.RESET_SUSPEND_POSTING:
      return {
        ...state,
        ...initialState
      };
    default:
      return state;
  }
}

export default suspendReducer;
